// Traduções das abas de frota dos Abastecimentos (04/11/2026), coletadas por glob em
// core/i18n/messages.ts.
export default {
  pt: {
    'abastecimento.grupo.pesada': 'Frota Pesada',
    'abastecimento.grupo.leve': 'Frota Leve',
    'abastecimento.grupo.maquinas': 'Máquinas',
    'abastecimento.grupo.outros': 'Outros',
    'abastecimento.grupo.filtro': 'Grupo',
    'abastecimento.grupo.hint.pesada': 'Espiga, Granel, Prancha, Caçamba e Tanque, lançados no Protheus a partir de 01/09/2026. O período é o HUB: o abastecimento ajustado entra no período escolhido para ele.',
    'abastecimento.grupo.hint.leve': 'Frota Leve, lançada no Protheus a partir de 01/09/2026. Classificação e Responsável vêm do cadastro do veículo.',
    'abastecimento.grupo.hint.maquinas': 'Máquinas, lançadas no Protheus a partir de 01/09/2026. As horas são a diferença entre o horímetro e o anterior.',
    'abastecimento.grupo.hint.outros': 'Fazenda, os demais tipos e a placa sem cadastro na frota do HUB.',
    'abastecimento.grupo.col.periodoOriginal': 'Período HUB original',
    'abastecimento.grupo.col.periodoAjustado': 'Período HUB ajustado',
    'abastecimento.grupo.col.hodometroAnterior': 'Hodômetro anterior',
    'abastecimento.grupo.col.horimetro': 'Horímetro',
    'abastecimento.grupo.col.horimetroAnterior': 'Horímetro anterior',
    'abastecimento.grupo.col.horas': 'Horas',
    'abastecimento.grupo.col.litrosHora': 'Litros/Hora',
    'abastecimento.grupo.col.classificacao': 'Classificação',
    'abastecimento.grupo.col.responsavel': 'Responsável',
    'abastecimento.grupo.col.kmPct': '% KM vazio e cheio',
    'abastecimento.grupo.col.maquina': 'Máquina',
    'abastecimento.grupo.col.operador': 'Operador',
    'abastecimento.grupo.col.valor': 'Valor',
    'abastecimento.grupo.vazio': 'Vazio',
    'abastecimento.grupo.cheio': 'Cheio',
    'abastecimento.grupo.anteriorHint': 'O Protheus não publica a leitura anterior. É a do abastecimento anterior da mesma placa, sem o Arla.',
    'abastecimento.grupo.semClassificacao': 'Sem classificação',
    'abastecimento.grupo.semModelo': 'Sem modelo',
    'abastecimento.grupo.semMunicipio': 'Sem município',
    'abastecimento.grupo.porLitro': '{{preco}} por litro',
    'abastecimento.grupo.card.kmRodado': 'KM rodado',
    'abastecimento.grupo.card.horasMotor': 'Horas motor',
    'abastecimento.grupo.card.mediaGeral': 'Média geral',
    'abastecimento.grupo.card.valorTotal': 'Valor total',
    'abastecimento.grupo.card.totalLitros': 'Total de litros',
    'abastecimento.grupo.card.custoKm': '{{valor}} por km',
    'abastecimento.grupo.card.valorHora': '{{valor}} por hora',
    'abastecimento.grupo.card.custoPorKm': 'Custo por KM',
    'abastecimento.grupo.card.valorPorHora': 'Valor por hora',
    'abastecimento.grupo.card.custoKmCombustivel': 'Custo por KM {{combustivel}}',
    'abastecimento.grupo.card.custoKmApoio': '{{valor}} em {{km}} km',
    'abastecimento.grupo.card.kmHintPesada': 'Soma dos intervalos válidos, sem Arla',
    'abastecimento.grupo.card.mediaHintPesada': 'KM dividido pelos litros de combustível, sem Arla',
    'abastecimento.grupo.card.kmHint': 'Soma dos intervalos válidos',
    'abastecimento.grupo.card.mediaHint': 'KM dividido por litros',
    'abastecimento.grupo.card.horasHint': 'Soma das diferenças entre o horímetro e o anterior',
    'abastecimento.grupo.card.mediaLhHint': 'Litros divididos pelas horas trabalhadas',
    'abastecimento.grupo.card.custoKmPesadaHint': 'O custo por KM é o valor de diesel e Arla dividido pelo KM rodado sem Arla.',
    'abastecimento.grupo.card.custoKmHint': 'O custo por KM é o valor total dividido pelo KM rodado.',
    'abastecimento.grupo.card.valorHoraHint': 'O valor por hora é o valor total dividido pelas horas trabalhadas.',
    'abastecimento.grupo.card.custoCombustivelHint': 'Valor abastecido do combustível dividido pelo KM rodado dos registros dele, mesmo quando a placa alterna o combustível.',
    'abastecimento.grupo.card.abastecimentos': '{{count}} abastecimentos',
    'abastecimento.grupo.custosPorCombustivel': 'Custo por KM por combustível',
    'abastecimento.grupo.rankings': 'Rankings',
    'abastecimento.grupo.ranking.media_motoristas': 'Média km/L por motorista',
    'abastecimento.grupo.ranking.menoresConsumos': 'Menores consumos',
    'abastecimento.grupo.ranking.maioresConsumos': 'Maiores consumos',
    'abastecimento.grupo.ranking.media_modalidades': 'Média km/L por modalidade',
    'abastecimento.grupo.ranking.media_bases': 'Média km/L por base',
    'abastecimento.grupo.ranking.litros_internos': 'Litros em postos internos',
    'abastecimento.grupo.ranking.litros_externos': 'Litros em postos externos',
    'abastecimento.grupo.ranking.media_placas': 'Média km/L por placa',
    'abastecimento.grupo.ranking.media_classificacoes': 'Média km/L por classificação',
    'abastecimento.grupo.ranking.media_filiais': 'Média km/L por filial',
    'abastecimento.grupo.ranking.litros_operadores': 'Litros por operador',
    'abastecimento.grupo.ranking.litros_maquinas': 'Litros por máquina',
    'abastecimento.grupo.ranking.media_maquinas': 'Média L/h por máquina',
    'abastecimento.grupo.ranking.media_modelos': 'Média L/h por modelo',
    'abastecimento.grupo.ranking.hint': 'Do menor para o maior. A média é o total de KM ou de horas dividido pelo total de litros do grupo, nunca a média das médias. Os rankings seguem os filtros da aba.',
    'abastecimento.grupo.ranking.hintPlacas': 'Embaixo da placa, o principal motorista: quem abasteceu mais litros dela no período filtrado.',
    'abastecimento.grupo.ranking.hintPostos': 'Os litros somados pelo município do posto, do menor para o maior.',
    'abastecimento.grupo.ranking.hintFiliais': 'Cada placa entra inteira na base do principal motorista. Sem cadastro ou sem base no HUB, a placa vai para FORA DO HUB.',
    'abastecimento.grupo.ranking.detalheLh': '{{horas}} h em {{litros}} L',
    'abastecimento.grupo.ranking.detalheKmTotal': '{{km}} km rodados em {{litros}} L',
    'abastecimento.periodo.ajustar': 'Ajustar período HUB',
    'abastecimento.periodo.titulo': 'Período HUB do abastecimento',
    'abastecimento.periodo.dataReal': 'Data do abastecimento',
    'abastecimento.periodo.original': 'Período original',
    'abastecimento.periodo.ajustado': 'Período ajustado',
    'abastecimento.periodo.semAjuste': 'Sem ajuste, fica no original',
    'abastecimento.periodo.ajuda': 'O abastecimento passa a compor o período escolhido na tabela, nos cartões e nos rankings, e sai do original. A data real não muda.',
    'abastecimento.periodo.salvar': 'Salvar',
    'abastecimento.periodo.salvo': 'Período ajustado.',
    'abastecimento.periodo.removido': 'Ajuste removido. O abastecimento voltou ao período original.',
    'abastecimento.periodo.quem': 'Ajustado por {{quem}} em {{quando}}',
  },
  en: {
    'abastecimento.grupo.pesada': 'Heavy fleet',
    'abastecimento.grupo.leve': 'Light fleet',
    'abastecimento.grupo.maquinas': 'Machines',
    'abastecimento.grupo.outros': 'Others',
    'abastecimento.grupo.filtro': 'Group',
    'abastecimento.grupo.hint.pesada': 'Espiga, Granel, Prancha, Caçamba and Tanque, recorded in Protheus from 09/01/2026 on. The period is the HUB one: an adjusted refueling counts in the period chosen for it.',
    'abastecimento.grupo.hint.leve': 'Light fleet, recorded in Protheus from 09/01/2026 on. Classification and Responsible come from the vehicle record.',
    'abastecimento.grupo.hint.maquinas': 'Machines, recorded in Protheus from 09/01/2026 on. Hours are the difference between the hour meter and the previous one.',
    'abastecimento.grupo.hint.outros': 'Farm, the other types and plates without a HUB fleet record.',
    'abastecimento.grupo.col.periodoOriginal': 'Original HUB period',
    'abastecimento.grupo.col.periodoAjustado': 'Adjusted HUB period',
    'abastecimento.grupo.col.hodometroAnterior': 'Previous odometer',
    'abastecimento.grupo.col.horimetro': 'Hour meter',
    'abastecimento.grupo.col.horimetroAnterior': 'Previous hour meter',
    'abastecimento.grupo.col.horas': 'Hours',
    'abastecimento.grupo.col.litrosHora': 'Litres/Hour',
    'abastecimento.grupo.col.classificacao': 'Classification',
    'abastecimento.grupo.col.responsavel': 'Responsible',
    'abastecimento.grupo.col.kmPct': '% empty and loaded km',
    'abastecimento.grupo.col.maquina': 'Machine',
    'abastecimento.grupo.col.operador': 'Operator',
    'abastecimento.grupo.col.valor': 'Amount',
    'abastecimento.grupo.vazio': 'Empty',
    'abastecimento.grupo.cheio': 'Loaded',
    'abastecimento.grupo.anteriorHint': 'Protheus does not publish the previous reading. It is the one from the previous refueling of the same plate, without Arla.',
    'abastecimento.grupo.semClassificacao': 'No classification',
    'abastecimento.grupo.semModelo': 'No model',
    'abastecimento.grupo.semMunicipio': 'No city',
    'abastecimento.grupo.porLitro': '{{preco}} per litre',
    'abastecimento.grupo.card.kmRodado': 'Distance traveled',
    'abastecimento.grupo.card.horasMotor': 'Engine hours',
    'abastecimento.grupo.card.mediaGeral': 'Overall average',
    'abastecimento.grupo.card.valorTotal': 'Total amount',
    'abastecimento.grupo.card.totalLitros': 'Total litres',
    'abastecimento.grupo.card.custoKm': '{{valor}} per km',
    'abastecimento.grupo.card.valorHora': '{{valor}} per hour',
    'abastecimento.grupo.card.custoPorKm': 'Cost per km',
    'abastecimento.grupo.card.valorPorHora': 'Cost per hour',
    'abastecimento.grupo.card.custoKmCombustivel': 'Cost per km {{combustivel}}',
    'abastecimento.grupo.card.custoKmApoio': '{{valor}} over {{km}} km',
    'abastecimento.grupo.card.kmHintPesada': 'Sum of the valid intervals, without Arla',
    'abastecimento.grupo.card.mediaHintPesada': 'Km divided by fuel litres, without Arla',
    'abastecimento.grupo.card.kmHint': 'Sum of the valid intervals',
    'abastecimento.grupo.card.mediaHint': 'Km divided by litres',
    'abastecimento.grupo.card.horasHint': 'Sum of the differences between the hour meter and the previous one',
    'abastecimento.grupo.card.mediaLhHint': 'Litres divided by the hours worked',
    'abastecimento.grupo.card.custoKmPesadaHint': 'Cost per km is the diesel and Arla amount divided by the distance without Arla.',
    'abastecimento.grupo.card.custoKmHint': 'Cost per km is the total amount divided by the distance.',
    'abastecimento.grupo.card.valorHoraHint': 'Cost per hour is the total amount divided by the hours worked.',
    'abastecimento.grupo.card.custoCombustivelHint': 'Amount of the fuel divided by the distance of its records, even when the plate switches fuel.',
    'abastecimento.grupo.card.abastecimentos': '{{count}} refuelings',
    'abastecimento.grupo.custosPorCombustivel': 'Cost per km by fuel',
    'abastecimento.grupo.rankings': 'Rankings',
    'abastecimento.grupo.ranking.media_motoristas': 'Km/L average by driver',
    'abastecimento.grupo.ranking.menoresConsumos': 'Lowest consumption',
    'abastecimento.grupo.ranking.maioresConsumos': 'Highest consumption',
    'abastecimento.grupo.ranking.media_modalidades': 'Km/L average by modality',
    'abastecimento.grupo.ranking.media_bases': 'Km/L average by base',
    'abastecimento.grupo.ranking.litros_internos': 'Litres at internal stations',
    'abastecimento.grupo.ranking.litros_externos': 'Litres at external stations',
    'abastecimento.grupo.ranking.media_placas': 'Km/L average by plate',
    'abastecimento.grupo.ranking.media_classificacoes': 'Km/L average by classification',
    'abastecimento.grupo.ranking.media_filiais': 'Km/L average by branch',
    'abastecimento.grupo.ranking.litros_operadores': 'Litres by operator',
    'abastecimento.grupo.ranking.litros_maquinas': 'Litres by machine',
    'abastecimento.grupo.ranking.media_maquinas': 'L/h average by machine',
    'abastecimento.grupo.ranking.media_modelos': 'L/h average by model',
    'abastecimento.grupo.ranking.hint': 'From lowest to highest. The average is the total km or hours divided by the total litres of the group, never the average of averages. Rankings follow the tab filters.',
    'abastecimento.grupo.ranking.hintPlacas': 'Under the plate, the main driver: whoever refueled the most litres of it in the filtered period.',
    'abastecimento.grupo.ranking.hintPostos': 'Litres added up by the city of the station, from lowest to highest.',
    'abastecimento.grupo.ranking.hintFiliais': 'Each plate goes entirely to the base of its main driver. Without a HUB record or base, the plate goes to FORA DO HUB.',
    'abastecimento.grupo.ranking.detalheLh': '{{horas}} h with {{litros}} L',
    'abastecimento.grupo.ranking.detalheKmTotal': '{{km}} km traveled with {{litros}} L',
    'abastecimento.periodo.ajustar': 'Adjust HUB period',
    'abastecimento.periodo.titulo': 'HUB period of the refueling',
    'abastecimento.periodo.dataReal': 'Refueling date',
    'abastecimento.periodo.original': 'Original period',
    'abastecimento.periodo.ajustado': 'Adjusted period',
    'abastecimento.periodo.semAjuste': 'No adjustment, stays in the original',
    'abastecimento.periodo.ajuda': 'The refueling counts in the chosen period in the table, the cards and the rankings, and leaves the original. The real date does not change.',
    'abastecimento.periodo.salvar': 'Save',
    'abastecimento.periodo.salvo': 'Period adjusted.',
    'abastecimento.periodo.removido': 'Adjustment removed. The refueling is back in its original period.',
    'abastecimento.periodo.quem': 'Adjusted by {{quem}} on {{quando}}',
  },
  es: {
    'abastecimento.grupo.pesada': 'Flota Pesada',
    'abastecimento.grupo.leve': 'Flota Liviana',
    'abastecimento.grupo.maquinas': 'Máquinas',
    'abastecimento.grupo.outros': 'Otros',
    'abastecimento.grupo.filtro': 'Grupo',
    'abastecimento.grupo.hint.pesada': 'Espiga, Granel, Prancha, Caçamba y Tanque, registrados en Protheus desde 01/09/2026. El período es el del HUB: el abastecimiento ajustado entra en el período elegido para él.',
    'abastecimento.grupo.hint.leve': 'Flota Liviana, registrada en Protheus desde 01/09/2026. Clasificación y Responsable vienen del registro del vehículo.',
    'abastecimento.grupo.hint.maquinas': 'Máquinas, registradas en Protheus desde 01/09/2026. Las horas son la diferencia entre el horómetro y el anterior.',
    'abastecimento.grupo.hint.outros': 'Hacienda, los demás tipos y la placa sin registro en la flota del HUB.',
    'abastecimento.grupo.col.periodoOriginal': 'Período HUB original',
    'abastecimento.grupo.col.periodoAjustado': 'Período HUB ajustado',
    'abastecimento.grupo.col.hodometroAnterior': 'Odómetro anterior',
    'abastecimento.grupo.col.horimetro': 'Horómetro',
    'abastecimento.grupo.col.horimetroAnterior': 'Horómetro anterior',
    'abastecimento.grupo.col.horas': 'Horas',
    'abastecimento.grupo.col.litrosHora': 'Litros/Hora',
    'abastecimento.grupo.col.classificacao': 'Clasificación',
    'abastecimento.grupo.col.responsavel': 'Responsable',
    'abastecimento.grupo.col.kmPct': '% KM vacío y cargado',
    'abastecimento.grupo.col.maquina': 'Máquina',
    'abastecimento.grupo.col.operador': 'Operador',
    'abastecimento.grupo.col.valor': 'Valor',
    'abastecimento.grupo.vazio': 'Vacío',
    'abastecimento.grupo.cheio': 'Cargado',
    'abastecimento.grupo.anteriorHint': 'Protheus no publica la lectura anterior. Es la del abastecimiento anterior de la misma placa, sin Arla.',
    'abastecimento.grupo.semClassificacao': 'Sin clasificación',
    'abastecimento.grupo.semModelo': 'Sin modelo',
    'abastecimento.grupo.semMunicipio': 'Sin municipio',
    'abastecimento.grupo.porLitro': '{{preco}} por litro',
    'abastecimento.grupo.card.kmRodado': 'KM recorrido',
    'abastecimento.grupo.card.horasMotor': 'Horas motor',
    'abastecimento.grupo.card.mediaGeral': 'Promedio general',
    'abastecimento.grupo.card.valorTotal': 'Valor total',
    'abastecimento.grupo.card.totalLitros': 'Total de litros',
    'abastecimento.grupo.card.custoKm': '{{valor}} por km',
    'abastecimento.grupo.card.valorHora': '{{valor}} por hora',
    'abastecimento.grupo.card.custoPorKm': 'Costo por KM',
    'abastecimento.grupo.card.valorPorHora': 'Valor por hora',
    'abastecimento.grupo.card.custoKmCombustivel': 'Costo por KM {{combustivel}}',
    'abastecimento.grupo.card.custoKmApoio': '{{valor}} en {{km}} km',
    'abastecimento.grupo.card.kmHintPesada': 'Suma de los intervalos válidos, sin Arla',
    'abastecimento.grupo.card.mediaHintPesada': 'KM dividido por los litros de combustible, sin Arla',
    'abastecimento.grupo.card.kmHint': 'Suma de los intervalos válidos',
    'abastecimento.grupo.card.mediaHint': 'KM dividido por litros',
    'abastecimento.grupo.card.horasHint': 'Suma de las diferencias entre el horómetro y el anterior',
    'abastecimento.grupo.card.mediaLhHint': 'Litros divididos por las horas trabajadas',
    'abastecimento.grupo.card.custoKmPesadaHint': 'El costo por KM es el valor de diésel y Arla dividido por el KM recorrido sin Arla.',
    'abastecimento.grupo.card.custoKmHint': 'El costo por KM es el valor total dividido por el KM recorrido.',
    'abastecimento.grupo.card.valorHoraHint': 'El valor por hora es el valor total dividido por las horas trabajadas.',
    'abastecimento.grupo.card.custoCombustivelHint': 'Valor del combustible dividido por el KM recorrido de sus registros, aunque la placa alterne el combustible.',
    'abastecimento.grupo.card.abastecimentos': '{{count}} abastecimientos',
    'abastecimento.grupo.custosPorCombustivel': 'Costo por KM por combustible',
    'abastecimento.grupo.rankings': 'Rankings',
    'abastecimento.grupo.ranking.media_motoristas': 'Promedio km/L por conductor',
    'abastecimento.grupo.ranking.menoresConsumos': 'Menores consumos',
    'abastecimento.grupo.ranking.maioresConsumos': 'Mayores consumos',
    'abastecimento.grupo.ranking.media_modalidades': 'Promedio km/L por modalidad',
    'abastecimento.grupo.ranking.media_bases': 'Promedio km/L por base',
    'abastecimento.grupo.ranking.litros_internos': 'Litros en puestos internos',
    'abastecimento.grupo.ranking.litros_externos': 'Litros en puestos externos',
    'abastecimento.grupo.ranking.media_placas': 'Promedio km/L por placa',
    'abastecimento.grupo.ranking.media_classificacoes': 'Promedio km/L por clasificación',
    'abastecimento.grupo.ranking.media_filiais': 'Promedio km/L por filial',
    'abastecimento.grupo.ranking.litros_operadores': 'Litros por operador',
    'abastecimento.grupo.ranking.litros_maquinas': 'Litros por máquina',
    'abastecimento.grupo.ranking.media_maquinas': 'Promedio L/h por máquina',
    'abastecimento.grupo.ranking.media_modelos': 'Promedio L/h por modelo',
    'abastecimento.grupo.ranking.hint': 'De menor a mayor. El promedio es el total de KM u horas dividido por el total de litros del grupo, nunca el promedio de los promedios. Los rankings siguen los filtros de la pestaña.',
    'abastecimento.grupo.ranking.hintPlacas': 'Debajo de la placa, el conductor principal: quien abasteció más litros de ella en el período filtrado.',
    'abastecimento.grupo.ranking.hintPostos': 'Los litros sumados por el municipio del puesto, de menor a mayor.',
    'abastecimento.grupo.ranking.hintFiliais': 'Cada placa entra entera en la base de su conductor principal. Sin registro o sin base en el HUB, la placa va a FORA DO HUB.',
    'abastecimento.grupo.ranking.detalheLh': '{{horas}} h con {{litros}} L',
    'abastecimento.grupo.ranking.detalheKmTotal': '{{km}} km recorridos con {{litros}} L',
    'abastecimento.periodo.ajustar': 'Ajustar período HUB',
    'abastecimento.periodo.titulo': 'Período HUB del abastecimiento',
    'abastecimento.periodo.dataReal': 'Fecha del abastecimiento',
    'abastecimento.periodo.original': 'Período original',
    'abastecimento.periodo.ajustado': 'Período ajustado',
    'abastecimento.periodo.semAjuste': 'Sin ajuste, queda en el original',
    'abastecimento.periodo.ajuda': 'El abastecimiento pasa a componer el período elegido en la tabla, las tarjetas y los rankings, y sale del original. La fecha real no cambia.',
    'abastecimento.periodo.salvar': 'Guardar',
    'abastecimento.periodo.salvo': 'Período ajustado.',
    'abastecimento.periodo.removido': 'Ajuste quitado. El abastecimiento volvió a su período original.',
    'abastecimento.periodo.quem': 'Ajustado por {{quem}} el {{quando}}',
  },
}
